import { observer } from "mobx-react";
import { h } from "preact";
import { t, translate } from "restaumatic-client";
function CartPromotionItemSelect(props) {
    const { id, freebies, onSelect, selectedValue } = props;
    const handleChange = (event) => {
        const value = event.target.value;
        onSelect(value);
    };
    return (h("div", { class: "m-select m-select--inline" },
        h("label", { for: id, class: "sr-only" }, translate(t.cart.promotions.select_product)),
        h("select", { id: id, class: "m-select__select", onChange: handleChange, ...{ value: selectedValue } }, freebies.map((freebie) => (h("option", { value: freebie.name, key: freebie.name }, freebie.name))))));
}
export default observer(CartPromotionItemSelect);
